import { defaultState as defaultTestState } from '@exp/redux/TestSlice';
import createStore from '@exp/redux/createStore';

import middleware from './middleware';
import reducers from './reducers';

// Create the base redux store for store-web.
export const store = createStore({
  name: `store-web | ${document.location.pathname}`,
  middleware,
  preloadedState: {
    test: defaultTestState({
      ...window.context.features,
      ...window.tests,
    }),
  },
  reducer: reducers,
});

export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];
/** the type that defines the global redux store */
export type RootState = ReturnType<typeof reducers>;
